import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cf3c2f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = { class: "dialog-login c-secondary" }
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = { class: "input c-thirdary" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "source" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "submit" }

import api from '@/api/userApi';
import devices from '@/store/device';
import { onMounted, reactive,computed } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18'

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    options: {
        resolve: Function,
        reject: Function,
        execute: Function,
    },
}

const store = useStore()
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)

const state = reactive({
    visible: false,
    content: '',
    key: '',
    value: '',
})


onMounted(async () => {
    loadDate()
})

async function loadDate() {
    let { key, content } = await api.getImageCode()
    state.key = key
    state.content = content
}

async function onSubmit() {
    if (!state.value) {
        devices.toast(store, "请输入内容")
        return
    }
    try {
        await props.options.execute(state.key, state.value)
        emits('close')
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}

function onCancel() {
    props.options.reject(new Event('cancel'))
    emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "close icon i-guanbi c-thirdary",
        onClick: onCancel
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(lang).imgcode_tip), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).value) = $event)),
          placeholder: _unref(lang).imgcode_placeholder
        }, null, 8, _hoisted_5), [
          [_vModelText, _unref(state).value]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _unref(state).content
          }, null, 8, _hoisted_7),
          _createElementVNode("a", {
            class: "link",
            onClick: loadDate
          }, _toDisplayString(_unref(lang).imgcode_reset), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", { onClick: onSubmit }, _toDisplayString(_unref(lang).imgcode_submit), 1)
      ])
    ])
  ]))
}
}

})